<template>
  <div>
    <div class="tooltip content-link">{{returnText}}&nbsp;
      <div class="tooltiptext">{{tooltipText}}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tooltip',
    props: ['text', 'tooltipText', 'separator'],
    computed: {
      returnText() {
        if (this.separator) {
          return this.text + ','
        } else {
          return this.text
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/colours';
  @import '../../../styles/breakpoints';

  .content-link {
    font-size: 14px;
    color: $content-link-blue;
    font-weight: bold;
  }

  @media screen and (max-width: $breakpoint-mobile) {
    .content-link {
      line-height: 1.71;
    }
  }

  /* Tooltip container */
  .tooltip {
    position: relative;
    display: inline-block;
  }

  /* Tooltip text */
  .tooltiptext {
    visibility: hidden;
    width: max-content;
    width: -moz-max-content;    /* Firefox/Gecko */
    max-width: 498px;
    min-height: 20px;
    border: solid 1px $lightest-gray;
    background-color: $lightest-gray;
    color: $text;
    font-weight: normal;
    font-size: 14px;
    padding: 24px 24px;
    margin-top: 5px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24);
    text-align: left;
    position: absolute;
    z-index: 1;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ CSS styles go here */
    .tooltiptext {
      min-width: 350px;
      max-width: 498px;
      word-wrap: normal;
    }
  }
  @supports (-ms-ime-align: auto) {
    // Edge styles
    .tooltiptext {
      min-width: 350px;
      max-width: 498px;
      word-wrap: normal;
    }
  }
</style>
